// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25327
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25327 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  Returns_Service_List: 'Returns_Service_List'
})

interface IPVTrackParamsRecord {
  /** 售后单列表页 */
Returns_Service_List: undefined
}

const sendPv = {
  /** PV-售后单列表页 */
Returns_Service_List: () => {
    eventTrackingUtils.submitPV({page_id:PageId.Returns_Service_List});
  },
}

interface IExpoTrackParamsRecord {
  /** 售后单列表曝光 */
Returns_Service_List_Item_Expo: {
/** 商品id  */
skuid: string,
/** 服务单id  */
service_id: string,
/** 退货状态  */
returnStatus: string}
  /** 售后单列表按钮曝光 */
Returns_Service_List_Item_Btn_Expo: {
/** 商品id  */
skuid: string,
/** 服务单id  */
service_id: string,
/** 退货状态  */
returnStatus: string,
/** 按钮名称  */
button_name: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 售后单列表曝光 */
  Returns_Service_List_Item_Expo:'Returns_Service_List_Item_Expo',
/** 售后单列表按钮曝光 */
  Returns_Service_List_Item_Btn_Expo:'Returns_Service_List_Item_Btn_Expo',
})

interface IClickTrackParamsRecord {
  /** 售后单列表点击 */
Returns_Service_List_Item: {
/** 商品id  */
skuid: string,
/** 服务单id  */
service_id: string,
/** 退货状态  */
returnStatus: string}
  /** 售后单列表按钮点击 */
Returns_Service_List_Item_Btn: {
/** 商品id  */
skuid: string,
/** 服务单id  */
service_id: string,
/** 退货状态  */
returnStatus: string,
/** 按钮名称  */
button_name: string}
}

const sendClickTrack = {
  /** 点击事件上报-售后单列表点击 */
Returns_Service_List_Item: (json_param: IClickTrackParamsRecord['Returns_Service_List_Item']) => {
    eventTrackingUtils.submitCL({event_id:'Returns_Service_List_Item',json_param});
  },
  /** 点击事件上报-售后单列表按钮点击 */
Returns_Service_List_Item_Btn: (json_param: IClickTrackParamsRecord['Returns_Service_List_Item_Btn']) => {
    eventTrackingUtils.submitCL({event_id:'Returns_Service_List_Item_Btn',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}